export default __webpack_public_path__ + "static/media/2team.e63e083a.jpeg";